<template>
	<div class="home">
		<head-top></head-top>
		<div class="login-bg">
			<el-carousel height="600px" class="banner-wrap">
				<el-carousel-item class="banner-box" v-for="(item,index) in carouselList" :key="index">
					<div class="banner-item" :style="{
						width:'100%',
						height:'100%', 
						backgroundImage:'url(' + item + ')',
						backgroundPosition:'center',
						backgroundSize:'cover'}">
					</div>
				</el-carousel-item>
			</el-carousel>
			<div class="content-w">
				<div class="login-right">
					<div class="header">
						<ul>
							<li class="active">{{$t('signIn.accountLogin')}}</li>
						</ul>
					</div>
					<div class="context">
						<div class="context-con1">
							<form>
								<div class="input-warp">
									<input class="input-text w-270" :placeholder="$t('signIn.accountNumber')" placeholder-class="placeholder-text" type="text" name="userName" v-model="userName" />
									<p class="regex">
									</p>
								</div>

								<input :class="passwordErr ? 'input-text w-270 err-input':'input-text w-270 '" @keyup.enter="checkPrama" :placeholder="$t('signIn.password')" type="password" name="password" v-model="password" />
							</form>
							<p class="regex">
								<span v-if="passwordErr">
									<i class="iconfont icon-cuowutishi"></i> {{$t('prompt.accountOrPasswordError')}}
								</span>
							</p>
						</div>
						<div class="footer">
							<input class="login-button" @click="checkPrama" type="button" :value="$t('button.signIn')" />
						</div>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			<Verify v-if="false" @success="login" explain="prompt.slideToTheRightToValidation" :captchaType="'blockPuzzle'" :imgSize="{width:'400px',height:'200px'}" ref="verify"></Verify>
		</div>
		<foot :showContact="true" bgColor="gray"></foot>
	</div>
</template>
<script>
import { getCode, login, getAllPlatform } from "@/api";
import codeStatus from "@/errorCode.js";
import { getToken, setToken, removeToken } from "@/auth";
import Verify from "./../components/verifition/Verify";
import { Message, MessageBox } from "element-ui";
import HeadTop from "@/components/header"
import Foot from "@/components/footer"
import md5 from 'js-md5';

export default {
    name: "home",
    data() {
        return {
            locale: "en-US",
            codeImg: "",
            userName: "",
            password: "",
            passwordErr: false,
            codeErr: false,
            code: "",
            timestamp: "",
            carouselList: [
                require("@/assets/login-banner2.png"),
                require("@/assets/login-banner4.png"),
                require("@/assets/login-banner1.png"),
                require("@/assets/login-banner3.png"),
            ]
        };
    },
    components: {
        Verify,
        HeadTop,
        Foot
    },
    mounted() {
        // this.timestamp = (new Date()).getTime()
        // this.getCode(this.timestamp)
        // this.login()
        console.log(window.location);
    },
    methods: {
        // login() {
        //     this.$router.push({path: "/platform"})
        // },
        /**
		 * 注册
		 */
        register() {
            // debugger

            //this.$router.push({ path: "/register" });

            let routeUrl = this.$router.resolve({
                path: "/register"
            });
            window.open(routeUrl.href, '_blank');

        },
        switch() { },
        /**
		 * 获取验证码
		 */
        async getCode(timestamp) {
            const resCode = await getCode(timestamp);
            this.codeImg = window.location.origin + resCode.config.url;
        },
        /**
		 * 登录
		 * code：{captchaVerification:'滑动登录返回的验证码'}
		 */
        login(code) {
            console.log(this.userName, this.password);
            /**
			 * 调用登录接口
			 * userName：用户名
			 * password：密码
			 * code.captchaVerification：验证码code
			 * randomStr：验证码时间戳字符串，固定值：blockPuzzle
			 */
            let param = {
                loginName: this.userName,
                password: md5(this.password)
            }

            if (code) {
                param.randomStr = "blockPuzzle"
                param.code = code.captchaVerification
            }

            login(param)
                .then(res => {
                    this.passwordErr = false;
                    console.log(res);
                    localStorage.setItem("userInfo", JSON.stringify(res));
                    localStorage.setItem(
                        "token",
                        "Bearer " + res.access_token
                    );
                    console.log("Bearer " + res.access_token);
                    let token = "Bearer " + res.access_token;
                    setToken(token);
                    this.getAllPlatform();
                })
                .catch(err => {
                    console.log(err);
                    //错误之后刷新验证码
                    // this.reLoadCodeImg()
                    if (err.status == codeStatus.passwordErr) {
                        this.passwordErr = true;
                    }
                });
        },
        /**
		 * 刷新验证码
		 */
        reLoadCodeImg() {
            this.timestamp = new Date().getTime();
            this.getCode(this.timestamp);
        },
        /**
		 * 跳转官网
		 */
        goOfficialWebsite() {
            window.location.href = window.HOME_URL || '';
        },
        /**
		 * 获取平台接口
		 */
        getAllPlatform() {
            getAllPlatform()
                .then(res => {
                    // 成功条件：code === 1
                    if (res.code !== 1) {
                        Message.error(res.msg || this.$t('prompt.noAuth'));
                        // 清理登录状态，避免无角色继续跳转
                        removeToken();
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        return;
                    }

                    if (res.data.length == 1) {
                        let roleLoginUrl = this.getPlatformBaseUrl(res.data[0].roleName);
                        let token = getToken();
                        console.log(token);
                        window.location.href = `${roleLoginUrl}#/fromlogin?token=${token}`;
                    } else if (res.data.length >= 2) {
                        this.$router.push({ path: "/platform" });
                    } else {
                        this.$router.push({ path: "/notauth" });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        /**
		 * 点击登录进行滑动验证
		 */
        checkPrama() {
            if (!this.userName || !this.password) {
                Message.error(this.$t('placeholder.pleaseEnterAccAndPsw'));
                return false;
            }

            // const agent = window.navigator.userAgent
            // const clientWidth = document.body.clientWidth

            // if( (agent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
            // if( clientWidth < 1200 ){
            this.login()
            // }else{
            // this.$refs.verify.show();
            // }
        }
    }
};
</script>
<style lang="scss" scoped>
.home {
	min-width: 1260px;
}
::v-deep .el-carousel__container img {
	max-height: 100%;
}

a {
	color: #4285f4;
}

.clear {
	clear: both;
}
body,
ul,
li,
p {
	padding: 0px;
	margin: 0px;
}

ul,
li {
	list-style: none;
}

.ml20 {
	margin-left: 20px;
}

input:focus {
	outline: none;
}

.header ul {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

.header ul li.active {
	color: #4285f4;
	font-weight: bold;
	border-bottom: 2px solid #4285f4;
	display: block;
	margin: 0px auto;
}

.content-w {
	width: 1200px;
	margin: 0px auto;
	margin-top: -600px;
	position: relative;
	z-index: 2;
}
.content-w::after {
	content: " ";
	clear: both;
}

.login-bg {
	height: 600px;
	min-width: 1200px;
	width: 100%;
}

.login-right {
	margin-top: 130px;
	width: 310px;
	padding: 20px;
	float: right;
	background: #fff;
	border-radius: 5px;

	.header ul {
		display: flex;
		text-align: center;
		justify-content: space-between;
		border-bottom: 1px solid #e6e6e6;

		li {
			cursor: pointer;
			text-align: center;
			height: 50px;
			line-height: 50px;
		}

		li.active {
			color: #4285f4;
		}
	}
}

.input-text {
	background: #f7f5fb;
	padding: 0px 20px;
	border-radius: 20px;
	color: #333;
	font-size: 14px;
	height: 35px;
	line-height: 35px;
	display: block;
	border: 1px solid #f7f5fb;
	&.err-input {
		border: 1px solid #ff0000;
	}
}

.regex {
	color: #ff0000;
	font-size: 12px;
	text-align: left;
	height: 30px;
	line-height: 30px;
	margin-left: 20px;
}

.w-270 {
	width: 270px;
}

.login-button {
	width: 310px;
	height: 40px;
	background: #4285f4;
	color: #fff;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
	border: none;
	border-radius: 25px;
	cursor: pointer;
}

.login-button:hover {
	border: none;
}

.yzm-img {
	width: 100px;
	height: 40px;
	margin: 0px auto;
	cursor: pointer;
}

.footer {
	justify-content: space-between;
	font-size: 14px;
	margin-bottom: 10px;
	text-align: right;
}

.footer span {
	color: #333333;
	font-size: 12px;
	margin-left: 5px;
}

.iconfont {
	font-size: 14px;
	margin-right: 5px;
}

.banner-wrap {
	width: 100%;
	height: 600px;
}
.banner-box {
	width: 100%;
	height: 600px;
}
.clear {
	clear: both;
}
</style>
